module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orderList"
  }, [_c('meta', {
    attrs: {
      "name": "description",
      "content": "以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"
    }
  }), _vm._v(" "), _c('headTop'), _vm._v(" "), _c('div', {
    staticClass: "orderText"
  }, [_c('div', {
    staticClass: "orderLeft"
  }, [_c('div', {
    staticClass: "portrait"
  }, [_c('img', {
    staticClass: "zhImg",
    attrs: {
      "src": _vm.zhUserUrl
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "portname"
  }, [_vm._v(_vm._s(_vm.zhUser))]), _vm._v(" "), _c('div', {
    staticClass: "orderLast"
  }, [_c('router-link', {
    staticClass: "orderC",
    attrs: {
      "to": "Myorder",
      "tag": "li"
    }
  }, [_vm._v("订单中心")]), _vm._v(" "), _c('router-link', {
    staticClass: "orderC",
    attrs: {
      "to": "MyBalance",
      "tag": "li"
    }
  }, [_vm._v("我的学费")]), _vm._v(" "), _c('router-link', {
    staticClass: "orderC",
    attrs: {
      "to": "scholarship",
      "tag": "li"
    }
  }, [_vm._v("我的奖学金")]), _vm._v(" "), _c('router-link', {
    staticClass: "orderC",
    attrs: {
      "to": "Mycoupons",
      "tag": "li"
    }
  }, [_vm._v("我的优惠券")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "orderRight"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('Bottom', {
    staticClass: "zuidi"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75907696","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orderList/orderList.vue
// module id = 559
// module chunks = 1